
import Vue from "vue";
import HeaderDropDownFilter, { OptionItem } from "@/components/BaseHeaderDropDownFilter.vue";

export type FilterCondition = {
  status?: string;
};

export type DataType = {
  filterCondition: FilterCondition;
  statusOptions: Array<OptionItem>;
};

export default Vue.extend({
  name: "ToiletListHeader",

  components: {
    HeaderDropDownFilter,
  },

  data(): DataType {
    return {
      filterCondition: {
        status: undefined,
      },
      statusOptions: [
        {
          label: "稼動",
          value: "running",
        },
        {
          label: "メンテ中",
          value: "maintaining",
        },
        {
          label: "準備中",
          value: "preparing",
        },
      ],
    };
  },

  methods: {
    updateFilterConditionAndSearch(): void {
      this.$emit("update-filter-condition", this.filterCondition);
      this.$emit("search");
    },
  },
});
